import { styled } from "@mui/system";
import { Box, Typography, Button } from "@mui/material";

// Main Wrapper
export const ComplianceWrapper = styled(Box)({
  padding: "0px", // Equivalent to `p: 3`
  width: "100%",
  background: "white",
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
  marginBottom: "16px", // Equivalent to `marginBottom: 2`
  gap: "0px", // Equivalent to `gap: 2`
});

// Header Section
export const HeaderSection = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
});

// Title Typography
export const ComplianceTitle = styled(Typography)({
  fontSize: "20px",
  padding: "20px",
  fontWeight: 500,
});

// Button Group
export const ButtonGroup = styled(Box)({
  display: "flex",
  gap: "16px",
});

// List Item Wrapper
export const ListItem = styled(Box)({
  borderRadius: "8px",
  border: "1px solid #EAF1FA",
  padding: "8px", // Equivalent to `p: 1`
});

// List Item Content
export const ListItemContent = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px", // Equivalent to `gap: 1`
});

// List Item Text
export const ListItemText = styled(Typography)(({ theme }) => ({
  color: theme.palette.myCustomColor.dark,
}));
